import { PAYROLL_FILE_UPLOAD_URL } from "../Api/APIURLS";

import Swal from "sweetalert2";
import { CommonAjaxPostWithFileUpload } from "../Api/CommonAjaxUtils";


export function fileupload(event, fieldName, formik) {  
 
    let msg = '';
    let allowedExtensions = ['pdf'];     
    let uploadedFileExtension = event.currentTarget.files[0].name.split('.').pop();
    let checkFileSize = checkUploadFileSize(event)
    const formData = new FormData();
    if (allowedExtensions.includes(uploadedFileExtension.toLowerCase()) && Boolean(checkFileSize) === false) {
        formData.append('file', event.currentTarget.files[0]);
        CommonAjaxPostWithFileUpload(PAYROLL_FILE_UPLOAD_URL, formData).then(response => {
            if (response !== undefined && response !== null && response !== '') {
                formik.setFieldValue(fieldName, response.data);
            }
            else {
                // logic here
            }
        })
    }
    else {
        msg = checkFileSize ? "File size exceeds 1 MB" : "please upload file in pdf format only";
        Swal.fire({ text: msg, icon: 'warning', confirmButtonColor: '#3085d6', });
        document.getElementById(fieldName).value = '';
    }
}
export function checkUploadFileSize(event) {
    var _size = event.currentTarget.files[0].size;
    let result = '';
    var exactSize = (Math.round(_size / 1024));
    if (exactSize > 1000) {
        result = true;
    }
    else {
        result = false;
    }
    return result
}
export const checkFileUploadSize = (event) => {
    var _size = event.currentTarget.files[0].size;
    let result = '';
    var exactSize = (Math.round(_size / 1024));
    if (exactSize > 1000) {
        result = true;
    }
    else {
        result = false;
    }
    return result
}